<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>  
          <v-flex xs12>
            <Progress :show="this.showProgress" />
          </v-flex> 
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="periodListWithNext"
              :items-per-page="50"
              item-key="id"
              sort-by="startDate"
              :sort-desc=true
              class="elevation-1"
              show-expand
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Periods</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">  
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Period</v-btn>
                    </template>                  
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>  
                            <v-flex xs12 sm4 md4>
                              <v-text-field :disabled="editedItem.id > 0" v-model="editedItem.text" label="Name"></v-text-field>
                            </v-flex>                          
                            <v-flex xs12 sm8 md8>
                              <v-text-field v-model="editedItem.explanation" label="Explanation"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm4 md4>                              
                              <DatePicker picker-label="Start Date" :date-value="editedItem.startDate" @dateSelected="editedItem.startDate=$event" /> 
                            </v-flex>
                            <v-flex xs12 sm4 md4>
                              <DatePicker picker-label="End date" :date-value="editedItem.endDate" @dateSelected="editedItem.endDate=$event" /> 
                            </v-flex>      
                            <v-flex xs12 sm4 md4>   
                              <v-combobox
                                :items="periodList"
                                label="Select Next Period"
                                v-model="editedItem.nextPeriod"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>                           
                            </v-flex>                                                                                                                                                                                               
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>


                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:expanded-item="{ headers, item: masterItem }">                
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    <v-flex xs10/>
                    <v-flex xs2>
                      Close Period 
                      <v-icon              
                          v-if="masterItem.sales"  
                          @click="closePeriod(masterItem, true)">
                          mdi-lock
                        </v-icon>    
                    </v-flex>
                    <v-flex xs12>

                      <v-data-table
                      :headers="salesHeaders"
                      :items="masterItem.sales"
                      :items-per-page="5"
                      item-key="id"
                      sort-by="id"
                      :sort-desc=true
                      class="elevation-1"
                      >                      
                      <template v-slot:body.append>                    
                      </template>             
                     
                    </v-data-table>

                    </v-flex>
                  </v-layout>
                </td>                
              </template>
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon              
                  v-if="item.status=='OPEN'"     
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>     
                <v-icon           
                  v-if="item.status=='OPEN'"     
                  color="red"  
                  @click="closePeriod(item, false)">
                  mdi-lock
                </v-icon>  
                   
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import Progress from '../../components/Progress';
const PERIOD_OPERATIONS_API_URL = 'periodOperations';
const PERIODS_API_URL = 'definitions/periods';
const ALL_PERIODS_API_URL = 'definitions/periodsAll';
const COEFFICIENTS_API_URL = 'definitions/bonusTypeCoefficients';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Progress
    },
    data () {
    return {
      dialog: false,
      search: '',
      showProgress : false,
      periodList: [],
      editedCoefficientItem: {},
      editedCoefficientIndex: -1,
      editedIndex: -1,
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Name', align: 'left', sortable: true, value: 'text'},
        { text: 'Start Date',  value: 'startDate'  },       
        { text: 'End Date',  value: 'endDate'  },  
        { text: 'Status',  value: 'status'  },
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    salesHeaders () {
      return [
        { text: 'Text',  value: 'saleText'  },          
        { text: 'Amount',  value: 'amount'  },    
        { text: 'Received Amount',  value: 'receivedAmount'  },    
        { text: 'Currency',  value: 'currency.code'  },    
        { text: 'Sales Actions', value: 'salesAction', sortable: false },
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Period' : 'Edit Period'
    },
    periodListWithNext(){
      return this.periodList.map((item) => {
        item.nextPeriod =  this.periodList.filter(i => {
         return i.id== item.nextPeriodId
          })[0];
        return item;
      });
    },   
  },
  created() {    
    this.getPerformancePeriodList();   
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.periodList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {        
        this.updatePeriod(this.editedItem);
      } else {
        this.addPeriod(this.editedItem);         
      }      
    },
    closePeriod(period, forceClose){    
      if(confirm('Are you sure you want to close this period?')){
        this.performClosePeriod(period, forceClose);
      } 
    },
    performClosePeriod(period, forceClose){    
      this.showProgress = true;
      var url = PERIOD_OPERATIONS_API_URL+"/"+period.id;
      if(forceClose)
        url+= "/forceClose";
      else
        url += "/close";   
      this.$axios.post(this.$apiurl + url, {})
      .then(response => {        
        if (response.status === 200) {
          if(response.data.success){
            this.$radio.$emit('success', {message:'Period Closed Sucessfully'});
            this.periodList.filter(i => {
              return i.id== period.id
            })[0].status = "CLOSED";  
          }
          if(response.data.saleResultDTO.saleList.length >0){
            this.periodList.filter(i => {
              return i.id== period.id
            })[0].sales = response.data.saleResultDTO.saleList;  
            this.$radio.$emit('warning', {message:'There are unpaid sales in period! Check the list!'});
          }
        } 
        this.showProgress = false;
      }).catch(error => {        
          console.log(error);
        }); 
    },
    addPeriod(item){
      this.$axios.post(this.$apiurl + PERIODS_API_URL, {
        text: item.text,
        startDate: item.startDate,
        status: 'OPEN',
        endDate: item.endDate,
        nextPeriodId: item.nextPeriod !=null ? item.nextPeriod.id : null,
        defaultsCreated: item.defaultsCreated ? item.defaultsCreated : 0
      })
      .then(response => {        
        if (response.status === 201) {
          this.$radio.$emit('success', {message:'Period Added Sucessfully'});
          this.getPerformancePeriodList();
          this.close();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updatePeriod(item){
      this.$axios.put(this.$apiurl + PERIODS_API_URL, {
        id: item.id,
        text: item.text,
        startDate: item.startDate,
        status: item.status,
        endDate: item.endDate,
        nextPeriodId: item.nextPeriod !=null ? item.nextPeriod.id : null,
        defaultsCreated: item.defaultsCreated ? item.defaultsCreated : 0
      })
      .then(response => {
        if (response.status === 200) {
          this.$radio.$emit('success', {message:'Period Updated Sucessfully'});
          this.getPerformancePeriodList();
          this.close();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteCoefficient(item){
      this.$axios.delete(this.$apiurl + COEFFICIENTS_API_URL+'/'+item.id)
      .then(response => {
        this.getBonusTypes();
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl + ALL_PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
